// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCQF6WEchsD-utarDoCddKqE4rJkXrZhOo',
    authDomain: 'shimenu-binaryfractal-dev.firebaseapp.com',
    databaseURL: 'https://shimenu-binaryfractal-dev.firebaseio.com',
    projectId: 'shimenu-binaryfractal-dev',
    storageBucket: 'shimenu-binaryfractal-dev.appspot.com',
    messagingSenderId: '883102688124',
    appId: '1:883102688124:web:724467a0ad2cc1a7717af9',
  },
  payment: {
    stripe: {
      connectExpress:
        'https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_NapHI3NjfWbVmEJ4hLR1JQE2Ad6OwOTG',
    },
  },
  api: 'https://us-central1-shimenu-binaryfractal-dev.cloudfunctions.net',
  gateway: 'https://admin-b9owjf5o.uc.gateway.dev',
  landing: 'https://dev.notmenu.com',
  storage: 'gs://shimenu-binaryfractal-dev.appspot.com',
  urlQr: 'https://dev.notmenu.app',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
